import React from 'react';
import classes from './card.module.scss';
import { Link } from '@reach/router';
import Stars from '../stars/stars';
import Like from '../like/like';

interface ICard {
  id: string;
  image: string;
  label: string;
  price: string;
  name: string;
  stars: number;
  reviews: any[];
  firstName?: string;
  username?: string;
  isFavorite?: boolean;
}

const Card = ({
  card,
  type,
  icon
}: {
  card: ICard;
  type?: string;
  icon?: React.ReactNode;
}) => {
  return (
    <div
      className={`${classes.card} ${type === 'bakers' ? classes.bakers : ''}`}
    >
      <Link
        to={
          type === 'bakers' ? `/baker/${card.username}` : `/product/${card.id}`
        }
        className={classes.img}
      >
        <img src={card.image} alt={card.label} />
      </Link>
      <div className={classes.cartBody}>
        <h3>
          <Link
            to={
              type === 'bakers'
                ? `/baker/${card.username}`
                : `/product/${card.id}`
            }
            style={{ textDecoration: 'none' }}
            data-e2e-id={'card-item-name'}
          >
            {type === 'bakers' ? card.firstName : card.name}
          </Link>
        </h3>
        <Stars
          stars={card.stars}
          reviews={card.reviews ? card.reviews.length : 10}
        />
        {type !== 'bakers' ? (
          <div>
            <div className={classes.price} data-e2e-id={'card-item-price'}>
              {card.price} ₴
            </div>
            <div className={classes.icon}>
              {icon || (
                <Like productId={card.id} isFavorite={card.isFavorite} />
              )}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default Card;
